import { Service, OptFormater } from "@TaankYou/services";
import { DownloadFile } from "../../Utils/Files";
import { errorsHandler } from "./errors";


export class InvoiceV2Service extends Service {
    errorsHandler = errorsHandler;
    pathPrepend = "/v3";

    Get = number => this._get(`/invoice-abstracts/${number}/`);
    GetList = opt => this._get(`/invoice-abstracts/${OptFormater(opt)}`);

    GetInvoicePaymentRequest = number => this._get(`/payment-requests/?invoiceNumbers=${number}`)
        .then(({ results }) => results[0] || null); 

    GetOrderInvoiceRequestList = (id, opt=undefined) => this._get(`/invoice-requests/${OptFormater({...(opt || {}), orderId: id})}`);
    GetOrderInvoiceRequest = id => this.GetOrderInvoiceRequestList(id)
        .then(({ results }) => results.filter(({isCancelled}) => !isCancelled)[0] || null); 

    Download = number => DownloadFile(`${this.pathPrepend}/invoice-abstracts/${number}/download/`, `facture-${number}.pdf`);
}


// WEBPACK FOOTER //
// ./src/services/InvoiceV2/service.js